import {Module} from 'vuex-module-decorators';

import {LogdownLogger} from '@/utils/LogdownLogger';
import {ILogger} from '@/utils/ILogger';

import {ILoraForwarderLoriotService} from '@/services/lora/forwarder/ILoraForwarderLoriot.service';
import {LoraForwarderLoriotService} from '@/services/lora/forwarder/LoraForwarderLoriot.service';

import {LoraForwarderStore} from '@/store/lora/LoraForwarder.store';
import {LoraForwarderState} from '@/model/lora/LoraForwarderState';
import {JobOutputMessage} from '@/model/lora/JobOutputMessage';
import {Inject} from 'inversify-props';
import {IEventsService} from '@/services/IEvents.service';

@Module({name: 'LoraForwarderLoriotStore', namespaced: true})
export default class LoraForwarderLoriotStore extends LoraForwarderStore {
  protected logger: ILogger = new LogdownLogger('LoraForwarderLoriotStore');

  @Inject(Symbol.for('IEventsService'))
  protected eventsService!: IEventsService;

  protected forwarderService: ILoraForwarderLoriotService = new LoraForwarderLoriotService();

  public get Enabled(): boolean | null {
    return this.enabled;
  }

  public get State(): LoraForwarderState {
    return this.forwarderState;
  }

  public get Logs(): JobOutputMessage[] {
    return this.logs;
  }
}
